import { get, post, del } from './httpRequest'
import {baseURL} from '../config'
export const loginUrl=(data)=>{
  return  baseURL+'app-api/im/member-user/login'
}

export const groupGet = (data) => {
  return get('app-api/im/group/get', data)
}
export const userInfo = (data) => {
  return get('app-api/im/member-user/get', data)
}
export const hisMess = (data) => {    //列表离线消息
  return get('app-api/im/member-user/message/offline-message', data)
}
export const history = (data) => {    //历史消息
  return get('app-api/im/member-user/message/history-page', data)
}

export const getOrder = (data) => {
  return get('app-api/im/product/list', data)
}
export const getOrderList = (data) => {
  return get('app-api/im/order/list', data)
}

export const getGroupList = (data) => {
  return get('app-api/im/member-user/message/chat-bar-message', data)
}

export const delGroup = (data) => {
  return del('app-api/im/member-user/message/delete', data)
}


export const getOssUrl=(data)=>{
  return post('/infra/file/get_presigned_url_for_oss_upload',data)
}


export const setNotRead=(data) => {    //设置未读
  return post('app-api/im/member-user/message/set-unread-message?wxappId='+data.wxappId+'&groupId='+data.groupId)
}

export const getNotReadList=(data) => {    //获取未读消息列表
  return get('app-api/im/member-user/message/get-unread-message', data) 
}

export const getNotClear=(data) => {
  const { wxappId, groupId } = data;
  const baseUrl = 'app-api/im/member-user/message/clean-unread-message';
  
  // 使用URLSearchParams处理查询参数
  return post(`${baseUrl}?${new URLSearchParams({ wxappId, ...(groupId && { groupId }) })}`);
}    //获取未读消息列表



export const getOrderType=(data) => {  
  return get('app-api/system/dict-data/get-dict', data)
}